module.exports = __webpack_public_path__ + "media/images/illustrations/two_stacked_yellow_boxes_small-2c107a72811b39fb6006042b93a66ffe.svg";